import { useContext, useRef } from "react";

import {
  CardGalleryBody,
  CardGalleryBodyActions,
  CardGalleryBodyText,
  CardGalleryBodyTrashIcon,
  CardGalleryContent,
  CardGalleryImage,
  CardGalleryVideo,
} from "./styled";

import { Tooltip, Typography } from "@mui/material";
import Button from "components/Form/Button";
import { CoreContext } from "context/CoreContext";
import moment from "moment";
import { parseStrapiImage } from "utils";
import { StatusLabel } from "../ScriptAssets";

export default function CardGallery({
  campaign,
  item,
  reload,
  removeAsset: removeAssetUp,
}) {
  const { setModal, user } = useContext(CoreContext);

  const openChat = () => {
    setModal({
      type: "chat",
      item: {
        ...item,
        campaignId: campaign.id,
      },
      reload,
    });
  };

  const videoRef = useRef(null);

  const deleteDeliverables = () => {
    setModal({
      type: "delete-delivery",
      item: {
        ...item,
        campaignId: campaign.id,
      },
      reload,
      removeAsset: removeAssetUp,
    });
  };

  return (
    <>
      <CardGalleryContent
        onMouseEnter={() => {
          const video = videoRef?.current;
          if (!video) return;
          // If the video is already ready to play, play it immediately
          if (video?.readyState >= 2) {
            video.play().catch((e) => console.error("Erro ao tocar vídeo:", e));
          } else {
            const onCanPlay = () => {
              video
                .play()
                .catch((e) => console.error("Erro ao tocar vídeo:", e));
              video.removeEventListener("canplay", onCanPlay);
            };
            video.addEventListener("canplay", onCanPlay);
          }
        }}
        onMouseLeave={() => videoRef?.current?.pause()}
      >
        {item?.isVideo ? (
          <>
            <CardGalleryVideo
              ref={videoRef}
              controls={false}
              autoPlay={false}
              muted
              loop
            >
              <source
                src={parseStrapiImage(item?.file?.url)}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </CardGalleryVideo>
          </>
        ) : (
          <CardGalleryImage image={item?.file?.url} />
        )}
        <CardGalleryBody>
          {item.uploadAt != null && (
            <Tooltip title={item?.uploadBy?.data?.attributes?.name || " "}>
              <Typography
                display={{ xs: "none", md: "block" }}
                style={{
                  margin: 0,
                  fontSize: "12px",
                }}
              >
                Enviado em: {moment(item.uploadAt).format("DD/MM/YYYY")} às{" "}
                {moment(item.uploadAt).format("HH:mm")}, por{" "}
                {item?.uploadBy?.data?.attributes?.name || " "}
              </Typography>
            </Tooltip>
          )}
          <CardGalleryBodyText>{item?.file?.name}</CardGalleryBodyText>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "30px",
            }}
          >
            <StatusLabel approved={item?.approved} />
            {item.approved !== null && item.approved !== undefined && (
              <Tooltip title={item?.ratedBy?.data?.attributes?.name || " "}>
                <Typography
                  display={{ xs: "none", md: "block" }}
                  style={{
                    margin: 0,
                    fontSize: "12px",
                    marginLeft: "5px",
                  }}
                >
                  Por {item?.ratedBy?.data?.attributes?.name || " "}{" "}
                  {moment(item.approvedAt).format("DD/MM/YYYY")} às{" "}
                  {moment(item.approvedAt).format("HH:mm")}
                </Typography>
              </Tooltip>
            )}
            {item?.approved == undefined && campaign?.status !== "finished" ? (
              <div
                style={{
                  fontWeight: 500,
                  paddingLeft: "12px",
                  color: "#5339E3",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setModal({
                    type: "review",
                    item: {
                      ...item,
                      campaignId: campaign.id,
                      ratedBy: user.id,
                      ratedAt: new Date(),
                    },
                    reload,
                  })
                }
              >
                Avaliar entregável
              </div>
            ) : null}
          </div>

          {campaign?.status !== "finished" && (
            <CardGalleryBodyTrashIcon
              data-tooltip-id="delete-delivery-tooltip"
              data-tooltip-content="Deletar entregável"
              onClick={deleteDeliverables}
            />
          )}
          <CardGalleryBodyActions>
            <Button
              primary
              outline
              onClick={
                item?.file?.url
                  ? () =>
                      window.open(
                        parseStrapiImage(item?.file?.url),
                        "campaing-asset"
                      )
                  : null
              }
            >
              DOWNLOAD
            </Button>
            <Button primary onClick={openChat}>
              VISUALIZAR
            </Button>
          </CardGalleryBodyActions>
        </CardGalleryBody>
      </CardGalleryContent>
    </>
  );
}
